import Typography from "typography";

import colors from "./colors";
import generalStyles from "./generalStyles";

const typography = new Typography({
	baseFontSize: "16px",
	bodyFontFamily: ["Gotham SSm A", "Gotham SSm B", "sans-serif"],
	headerFontFamily: ["Gotham SSm A", "Gotham SSm B", "sans-serif"],
	bodyWeight: 300,
	baseLineHeight: 1.75,
	overrideStyles: ({ adjustFontSizeTo, rhythm }, options, styles) => ({
		html: {
			overflowY: "initial",
			overflowX: "hidden",
			width: "100vw"
		},
		h1: {
			marginBottom: rhythm(1),
			lineHeight: rhythm(1.5),
			color: colors.danube
		},
		p: {
			color: colors.fiord
		},
		[generalStyles.mediaQueries.md]: {
			h1:{
				fontSize: rhythm(0.857142857),
				marginBottom: rhythm(0.6),
			}
		},
		[generalStyles.mediaQueries.xs]:{
			h1:{
				fontSize: '16px',
				lineHeight: '24px'
			}
		}
	})
});

export default typography;



// WEBPACK FOOTER //
// ./src/utils/typography.js